<section id="how-work" class="saas1 howitwork" [ngStyle]="{'background-image': 'url(assets/images/saas1/work-bg.png)'}">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="title">
                    <img src="../../../../assets/images/saas1/title-logo.png" alt="title-logo" class="img-fluid mb-3">
                    <div class="main-title">
                        <h2>
                            Tabellen Vorschau
                        </h2>
                    </div>
                    <hr>
                    <div class="sub-title">
                        <p class="p-padding">
                            Sie sehen hier eine <b>Vorschau</b> Ihrer konfigurierten Lead-Tabelle. Nutzen Sie die vielfältigen Einstellungsmöglichkeiten, um exakt die Spalten und Informationen auszuwählen, die für Ihr Unternehmen relevant sind.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabellen Vorschau -->
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12">
                <div class="table-responsive shadow rounded">
                    <table mat-table [dataSource]="dataSource" class="table table-striped table-hover table-bordered rounded-3 shadow-sm bg-white align-middle">
                        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                            <th mat-header-cell *matHeaderCellDef class="text-capitalize bg-gradient-green">
                                {{ column }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element[column] }}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>

            <!-- Hinweis: Download nach Kauf -->
            <div class="bg-white rounded-3 p-5 mt-4 shadow-sm border">
                <div class="mb-4">
                    <p class="fs-5 mb-2">
                        <span class="text-success fw-semibold">Hinweis:</span> <br>
                        Der <b>Download der vollständigen Daten</b> ist nach dem Kauf möglich.
                        Nach Abschluss Ihrer Bestellung stehen Ihnen die gewünschten Informationen im <b>Excel</b>-, <b>CSV</b>- oder <b>JSON</b>-Format im Kundenbereich zur Verfügung.
                    </p>
                </div>

                <div class="mb-4">
                    <h6 class="text-uppercase fw-semibold mb-3 text-dark opacity-75" style="letter-spacing:.08em;font-size:.97rem;">So funktioniert es</h6>
                    <ol class="fs-5 mb-0 ps-3">
                        <li class="mb-2">Passen Sie Ihre Tabelle mit den gewünschten Spalten und Filtern individuell an.</li>
                        <li class="mb-2">Klicken Sie auf <span class="fw-semibold">„Kaufen“</span>, um Ihre Konfiguration zu sichern und Zugriff auf die vollständigen Daten zu erhalten.</li>
                        <li>Nach dem Kauf finden Sie Ihre fertige Tabelle im Kundenbereich – sofort verfügbar zum Download im gewünschten Format.</li>
                    </ol>
                </div>

                <div class="pt-2">
                    <p class="fs-6 text-muted mb-0">
                        Sie haben Fragen oder benötigen Unterstützung? Unser <span class="fw-semibold">Support-Team</span> ist jederzeit gerne für Sie da.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-5"></div>
</section>
